import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import NoCoupon from '../../assets/NoCoupons.png'
import { useNavigate } from "react-router-dom";
import logger from "../../Utils/logger";

export default function NoCoupons({machineId}) {
    logger.log("machineID",machineId)
    const navigate=useNavigate()
    const orderNow=()=>{
        //navigate(`/items?machineId=${machineId}&value=null&showItems=true`)
        navigate('/')
    }
  return (
    <Container
      maxWidth="sm"
      sx={{
        height: "100vh",
       
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        py: 6,
      }}
    >
      {/* Center Content */}
      <Box textAlign="center" mt={8} p={5}>
        {/* Icon Placeholder (replace with image if you have one) */}
        <div style={{display:"flex",justifyContent:"center"}}> 
    <img src={NoCoupon} style={{width:"80px",height:"80px"}}/>
    </div>

        <Typography
          variant="h6"
          fontSize={"16px"}
          fontWeight={600}
          sx={{ color: "#a65a2e", mt: 2,mb:2 }}
        >
          No Coupons Available On This Order
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "#c08a6a",
            maxWidth: 260,
            mx: "auto",
            fontSize:"14px"
          }}
        >
          Your Next Order Might Surprise You With New Rewards/Coupons
        </Typography>
      </Box>

      {/* Button */}
      <div style={{display:"flex",justifyContent:"center"}}>
      <Button
        variant="contained"
        fullWidth
        sx={{
          bgcolor: "#0aa06e",
          borderRadius: 3,
          py: 1.6,
          fontWeight: 600,
          textTransform: "none",
          fontSize: "16px",
          width:"50%",
          "&:hover": {
            bgcolor: "#088a5f",
          },
        }}
        onClick={(e)=>{orderNow(e)}}
      >
        Order Now
      </Button>
      </div>
    </Container>
  );
}
